<template>
  <div class="footer">
    <a class="powered-by"  href="https://airsset.com" target="_blank">Powered by Airsset</a>
  </div>
</template>

<style>

#airsset_widget .footer {
  width: 100%;
  left: 0%;
  text-align: center;
  position: relative;
  margin-top: 0;
  padding: 10px 0;
  clear:both;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background: white;
}

#airsset_widget a:link.powered-by, a:visited.powered-by{
  color: #48a0d3;
  font-weight: bold;
  font-size: 0.7rem;
}

</style>

<script>
  export default {
    name: "Footer"
  }
</script>
